/* src/app/views/display/components/modals/select-location-displays-modal/select-location-displays-modal.component.scss */
.bs-italic {
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: italic;
}
.bs-regular {
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: normal;
}
.bs-medium {
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-style: normal;
}
.bs-bold-italic {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-style: italic;
}
.bs-semi-bold {
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-style: normal;
}
.bs-semi-bold-italic {
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-style: italic;
}
.bs-bold {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-style: normal;
}
.f6px {
  font-size: 0.375rem;
}
.f8px {
  font-size: 0.5rem;
}
.f10px {
  font-size: 0.625rem;
}
.f11px {
  font-size: 0.6875rem;
}
.f12px {
  font-size: 0.75rem;
}
.f13px {
  font-size: 0.8125rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
:host ::ng-deep .mat-expansion-panel {
  border-radius: 0 !important;
  border-bottom: 1px solid #f2f2f2;
}
:host ::ng-deep .mat-expansion-panel-header:not(:focus-visible) {
  background: none !important;
}
:host ::ng-deep .mat-expansion-panel-header.mat-expanded:hover {
  background: none !important;
}
:host ::ng-deep .mat-expansion-panel:not(.mat-expanded):not([aria-disabled=true]) .mat-expansion-panel-header:hover {
  background: none !important;
}
:host ::ng-deep .mat-expansion-panel-header {
  height: unset !important;
  padding: 1rem 0.3rem 1rem 0 !important;
}
:host ::ng-deep .mat-expansion-panel-body {
  padding: 0 0 !important;
}
:host ::ng-deep .disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}
:host ::ng-deep .mat-expansion-indicator::after {
  height: 0.8rem !important;
  width: 0.8rem !important;
  color: black !important;
  vertical-align: initial !important;
}
:host ::ng-deep .mat-content {
  overflow: visible;
}
:host app-search-with-look-ahead {
  display: block;
  padding-top: 0.75rem;
}
.select-all-displays-container {
  margin-top: 1rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid #f2f2f2;
  padding: 1rem 0;
}
.select-all-displays-text {
  font-size: 0.75rem;
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-style: normal;
  color: #222222;
}
.n-selected {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1.5rem;
}
.checked-count {
  font-size: 0.6rem;
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-style: normal;
}
.empty-search-state {
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-style: normal;
  font-size: 0.875rem;
  color: #222222;
}
/*# sourceMappingURL=select-location-displays-modal.component.css.map */
